module.exports = {"511102001":"张公桥街道","511102002":"泊水街街道","511102003":"上河街街道","511102004":"大佛街道","511102005":"肖坝街道","511102006":"通江街道","511102007":"柏杨街道","511102101":"牟子镇","511102102":"土主镇","511102103":"白马镇","511102104":"茅桥镇","511102105":"青平镇","511102106":"苏稽镇","511102107":"水口镇","511102108":"安谷镇","511102109":"棉竹镇","511102110":"全福镇","511102111":"童家镇","511102112":"九峰镇","511102113":"罗汉镇","511102114":"临江镇","511102115":"车子镇","511102200":"悦来乡","511102201":"关庙乡","511102202":"石龙乡","511102203":"剑峰乡","511102204":"凌云乡","511102205":"迎阳乡","511102206":"九龙乡","511102207":"普仁乡","511102208":"平兴乡","511102209":"杨湾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511102.json
// module id = 2146
// module chunks = 0